/* ============================================================
   MC SEARCH — predictive search for a 964-piece catalogue
   ------------------------------------------------------------
   The House sells 964 variations across 65 collections and, until
   now, offered no way to search them. This adds a trigger next to
   the bag and a sheet that queries Shopify's own predictive search.

   Market safe: every URL comes from Shopify.routes, and the API
   already returns market-prefixed product URLs (/en-eu/products/…).

   Header room: the home page header is full at narrow desktop
   widths. The trigger is only inserted where it actually fits;
   Cmd/Ctrl+K opens the sheet either way.
   ============================================================ */
(function () {
  'use strict';

  var root = '/';
  try {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
  } catch (e) {}
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var currency = 'EUR';
  try { if (window.Shopify && window.Shopify.currency) currency = window.Shopify.currency.active || 'EUR'; } catch (e) {}

  var GROUPING = { EUR: 'de-DE', CHF: 'de-CH', GBP: 'en-GB', USD: 'en-US', AED: 'en-US' };
  var SYMBOL = { EUR: '€', GBP: '£', USD: '$', CHF: 'CHF ', AED: 'AED ' };

  var sheet = null, input = null, out = null;
  var timer = null, ctrl = null, lastQuery = '', lastFocus = null;

  var CSS = [
    '.mcs-t{position:relative;display:inline-flex;align-items:center;justify-content:center;height:40px;width:31px;padding:0;background:none;border:0;cursor:pointer;color:inherit;font:inherit;-webkit-appearance:none;appearance:none}',
    '.mcs-t svg{width:18px;height:18px;stroke:currentColor;fill:none;stroke-width:1.5}',
    '.mcs-t:focus-visible{outline:2px solid currentColor;outline-offset:3px;border-radius:4px}',
    '.mcs{position:fixed;inset:0;z-index:2147483500;visibility:hidden}',
    '.mcs.is-on{visibility:visible}',
    '.mcs-veil{position:absolute;inset:0;background:rgba(7,17,31,.42);opacity:0;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);transition:opacity .28s ease}',
    '.mcs.is-on .mcs-veil{opacity:1}',
    '.mcs-sheet{position:absolute;top:0;left:0;right:0;max-height:86vh;display:flex;flex-direction:column;background:#fff;color:#0D1B2E;transform:translateY(-101%);transition:transform .34s cubic-bezier(.22,.61,.36,1);box-shadow:0 24px 60px rgba(7,17,31,.22)}',
    '.mcs.is-on .mcs-sheet{transform:none}',
    '@media (prefers-reduced-motion:reduce){.mcs-veil,.mcs-sheet{transition:none}}',
    '.mcs-bar{display:flex;align-items:center;gap:16px;padding:22px 28px;border-bottom:1px solid rgba(13,27,46,.10)}',
    '.mcs-bar svg{flex:0 0 20px;width:20px;height:20px;stroke:#5C6678;fill:none;stroke-width:1.5}',
    '.mcs-in{flex:1;min-width:0;border:0;outline:0;background:none;color:#0D1B2E;font-family:Jost,system-ui,sans-serif;font-size:22px;letter-spacing:.04em;padding:4px 0;-webkit-appearance:none;appearance:none}',
    '.mcs-in::placeholder{color:#9AA6B8}',
    '.mcs-in::-webkit-search-cancel-button{display:none}',
    '.mcs-x{background:none;border:0;cursor:pointer;padding:6px;margin:-6px;color:#5C6678;font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-family:Jost,system-ui,sans-serif;white-space:nowrap}',
    '.mcs-x:hover{color:#0D1B2E}',
    '.mcs-x:focus-visible{outline:2px solid #0D1B2E;outline-offset:2px}',
    '.mcs-body{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:22px 28px 28px}',
    '.mcs-note{margin:0;color:#5C6678;font-size:14px;line-height:1.6}',
    '.mcs-lab{margin:0 0 14px;font-family:Jost,system-ui,sans-serif;font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:#9AA6B8}',
    '.mcs-cols{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 26px;padding:0;list-style:none}',
    '.mcs-cols a{display:inline-block;padding:8px 15px;border:1px solid rgba(13,27,46,.18);border-radius:999px;font-family:Jost,system-ui,sans-serif;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#0D1B2E;text-decoration:none}',
    '.mcs-cols a:hover{border-color:#07111F}',
    '.mcs-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(168px,1fr));gap:22px;margin:0;padding:0;list-style:none}',
    '.mcs-card{display:block;text-decoration:none;color:inherit}',
    '.mcs-im{aspect-ratio:1;background:#F6F7F9;border-radius:12px;display:flex;align-items:center;justify-content:center;padding:14px;overflow:hidden}',
    '.mcs-im img{max-width:100%;max-height:100%;object-fit:contain;mix-blend-mode:multiply}',
    '.mcs-ti{display:block;margin-top:11px;font-family:Jost,system-ui,sans-serif;font-size:11px;letter-spacing:.1em;text-transform:uppercase;line-height:1.5}',
    '.mcs-pr{display:block;margin-top:5px;font-size:12.5px;color:#5C6678;font-variant-numeric:tabular-nums}',
    '.mcs-all{display:inline-block;margin-top:26px;font-family:Jost,system-ui,sans-serif;font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#0D1B2E;text-decoration:none;border-bottom:1px solid rgba(13,27,46,.35);padding-bottom:3px}',
    'body.mcs-lock{overflow:hidden}',
    /* Le rang de l'en-tete d'accueil deborde deja de ~20 px entre 1024 et
       1280 px : la marque, sept liens, la pastille de rendez-vous et le sac
       ne tiennent pas. On resserre les gouttieres sur cette seule bande, ce
       qui remet le sac dans le cadre et libere la place de la loupe. */
    '@media (min-width:1024px) and (max-width:1279px){#root header>div{padding-left:20px!important;padding-right:20px!important}#root header nav{gap:.55rem!important}}'
  ].join('');

  function injectCSS() {
    var s = document.createElement('style');
    s.id = 'mc-search-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function money(decimalString) {
    var v = parseFloat(decimalString);
    if (!isFinite(v)) return '';
    try {
      var n = new Intl.NumberFormat(GROUPING[currency] || 'en', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(v);
      return (SYMBOL[currency] || currency + ' ') + n;
    } catch (e) { return v.toFixed(2) + ' ' + currency; }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function thumb(url) {
    if (!url) return null;
    return url.indexOf('?') === -1 ? url + '?width=400' : url + '&width=400';
  }

  /* ---------------------------------------------------------- the trigger */

  var ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="11" cy="11" r="7"></circle><path d="M16.5 16.5 21 21"></path>' +
    '</svg>';

  function buildTrigger() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mcs-t';
    b.setAttribute('aria-label', 'Search the House');
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = ICON;
    b.addEventListener('click', function () { open(); });
    return b;
  }

  /* Put one trigger in this container, just before the bag when the bag is a
     direct child, and never two. */
  function ensure(host, ref) {
    var t = null, i;
    for (i = 0; i < host.children.length; i++) {
      if (host.children[i].className === 'mcs-t') { t = host.children[i]; break; }
    }
    if (t) return t;
    t = buildTrigger();
    if (ref && ref.parentNode === host) host.insertBefore(t, ref);
    else host.appendChild(t);
    return t;
  }

  function drop(host) {
    for (var i = host.children.length - 1; i >= 0; i--) {
      if (host.children[i].className === 'mcs-t') host.removeChild(host.children[i]);
    }
  }

  /* The home page header is the app's own and is already full at narrow
     desktop widths: measure the free space before inserting rather than
     pushing the row into overflow. Cmd/Ctrl+K works either way. */
  function slack(row) {
    var w = 0, i;
    for (i = 0; i < row.children.length; i++) {
      w += row.children[i].getBoundingClientRect().width;
    }
    /* Discount our own trigger wherever it sits, otherwise inserting it would
       shrink the measured room and the next pass would remove it again. */
    var mine = row.querySelectorAll('.mcs-t');
    for (i = 0; i < mine.length; i++) w -= mine[i].getBoundingClientRect().width;
    var cs = window.getComputedStyle(row);
    var inner = row.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
    return inner - w;
  }

  function place() {
    var nav = document.querySelector('.mc-nav-in');
    if (nav) {
      ensure(nav, nav.querySelector('.mcb'));
      tint(nav.querySelector('.mc-links a'));
      return;
    }

    var row = document.querySelector('#root header > div');
    if (!row) return;

    /* The app keeps a separate cluster for narrow screens; it always has room. */
    var mob = null;
    for (var i = 0; i < row.children.length; i++) {
      var cl = row.children[i].className;
      if (typeof cl === 'string' && cl.indexOf('lg:hidden') !== -1) { mob = row.children[i]; break; }
    }
    if (mob) ensure(mob, mob.querySelector('button[data-mcb]'));

    /* Sit inside the app's nav, just before the bag, so the order reads the
       same here as on the Liquid pages: search, then bag. */
    var navEl = row.querySelector('nav');
    var bag = navEl ? navEl.querySelector('button[data-mcb]') : null;
    if (slack(row) >= 44 && navEl && bag) {
      drop(row);
      ensure(navEl, bag);
    } else {
      if (navEl) drop(navEl);
      drop(row);
    }
    tint(row.querySelector('nav a'));
  }

  function tint(ref) {
    if (!ref) return;
    var c = window.getComputedStyle(ref).color;
    var all = document.querySelectorAll('.mcs-t');
    for (var i = 0; i < all.length; i++) {
      if (c && c !== all[i].style.color) all[i].style.color = c;
    }
  }

  /* ---------------------------------------------------------- the sheet */

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'mcs';
    sheet.innerHTML =
      '<div class="mcs-veil" data-close></div>' +
      '<div class="mcs-sheet" role="dialog" aria-modal="true" aria-label="Search the House">' +
        '<form class="mcs-bar" role="search" action="' + root + 'search" method="get">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="11" cy="11" r="7"></circle><path d="M16.5 16.5 21 21"></path></svg>' +
          '<input class="mcs-in" type="search" name="q" autocomplete="off" autocorrect="off" ' +
            'spellcheck="false" placeholder="Oxford, shearling, cognac patina…" aria-label="Search the House">' +
          '<button type="button" class="mcs-x" data-close>Close</button>' +
        '</form>' +
        '<div class="mcs-body" aria-live="polite"></div>' +
      '</div>';

    input = sheet.querySelector('.mcs-in');
    out = sheet.querySelector('.mcs-body');

    sheet.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-close')) close();
    });
    sheet.querySelector('form').addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 220);
    });

    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase();
      if (k === 'k' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); return; }
      if (!sheet.classList.contains('is-on')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = sheet.querySelectorAll('input, a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.body.appendChild(sheet);
    hint();
  }

  function hint() {
    out.innerHTML = '<p class="mcs-note">Search 964 pieces by model, leather, colour or patina&nbsp;— ' +
      '&ldquo;penny loafer&rdquo;, &ldquo;shearling&rdquo;, &ldquo;box calf&rdquo;.</p>';
  }

  function run() {
    var q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;

    if (q.length < 2) { hint(); return; }
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = ('AbortController' in window) ? new AbortController() : null;

    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=9' +
      '&resources[options][unavailable_products]=last';

    fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (input.value.trim() !== q) return;   /* a newer keystroke won */
        render(q, (j.resources && j.resources.results) || {});
      })
      ['catch'](function (err) {
        if (err && err.name === 'AbortError') return;
        out.innerHTML = '<p class="mcs-note">Search is unavailable for a moment. ' +
          '<a href="' + root + 'search?q=' + encodeURIComponent(q) + '">Open the full results page</a>.</p>';
      });
  }

  function render(q, res) {
    var products = res.products || [];
    var collections = res.collections || [];

    if (!products.length && !collections.length) {
      out.innerHTML = '<p class="mcs-note">Nothing matches &ldquo;' + esc(q) + '&rdquo;. ' +
        'Try a model name, a leather or a colour&nbsp;— or write to the House at ' +
        '<a href="mailto:info@mathieucastanier.com">info@mathieucastanier.com</a> ' +
        'and we will make it.</p>';
      return;
    }

    var html = '';

    if (collections.length) {
      html += '<p class="mcs-lab">Collections</p><ul class="mcs-cols">' +
        collections.map(function (c) {
          return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        }).join('') + '</ul>';
    }

    if (products.length) {
      html += '<p class="mcs-lab">Pieces</p><ul class="mcs-grid">' +
        products.map(function (p) {
          var img = thumb(p.image || (p.featured_image && p.featured_image.url));
          var price = money(p.price);
          return '<li><a class="mcs-card" href="' + esc(p.url) + '">' +
            '<span class="mcs-im">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') +
            '</span>' +
            '<span class="mcs-ti">' + esc(p.title) + '</span>' +
            (price ? '<span class="mcs-pr">from ' + price + '</span>' : '') +
          '</a></li>';
        }).join('') + '</ul>';
    }

    html += '<a class="mcs-all" href="' + root + 'search?q=' + encodeURIComponent(q) +
      '">See every result &rarr;</a>';

    out.innerHTML = html;
  }

  function open() {
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.classList.add('is-on');
    document.body.classList.add('mcs-lock');
    input.focus();
    input.select();
  }

  function close() {
    sheet.classList.remove('is-on');
    document.body.classList.remove('mcs-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------------------------------------------------------- boot */

  function start() {
    injectCSS();
    build();
    place();

    try {
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; place(); });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}

    var tries = 0;
    var t = setInterval(function () {
      tries++;
      place();
      if (tries > 40) clearInterval(t);
    }, 250);

    var sizing = false;
    window.addEventListener('resize', function () {
      if (sizing) return;
      sizing = true;
      requestAnimationFrame(function () { sizing = false; place(); });
    }, { passive: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
